<script lang='ts'>
    import { getLanguage, selectLanguage } from '../helpers/url';

    const currentLang = getLanguage();


    function changeLanguage(e){
        const options = e.target.options;
        const lang = options[options.selectedIndex].value;
        selectLanguage(lang);
    }
</script>

<!--<div class='language-wrapper'>-->
<!--    <i class='fas fa-language'></i>-->
<!--    <div class='input-wrapper icon price'>-->
<!--        <select class='input-field'-->
<!--                on:change={changeLanguage}-->
<!--                type='text' placeholder='Language'>-->

<!--            <option value='en' selected={currentLang === 'en' ? true : false}>-->
<!--                English-->
<!--            </option>-->
<!--            <option value='ja' selected={currentLang === 'ja' ? true : false}>-->
<!--                日本語-->
<!--            </option>-->
<!--            <option value='fr' selected={currentLang === 'fr' ? true : false}>-->
<!--                French-->
<!--            </option>-->
<!--            <option value='zh' selected={currentLang === 'zh' ? true : false}>-->
<!--                中文-->
<!--            </option>-->

<!--        </select>-->
<!--    </div>-->
<!--</div>-->


<style>
    .language-wrapper {
        display: flex;
    }

    .language-wrapper > i {
        width: 55px;
        font-size: 38px;
        line-height: 29px;
        color: grey;
    }

    .input-wrapper {
        flex: 1;
        height: 26px;
    }

    .input-field {
        height: 100%;
    }
</style>